(function () {
hubspot.define('hubspot.embedding.common', ['Q'], function(Q) {
  var APP_DONE, APP_HOSTID, APP_PARAMS, APP_READY, ORIGIN_ALL, channels, getOrigin, handleMessageReceived, hasHsDebugParam, hsDebugParam, isHsDebugging, listenTo, passthroughHsDebugParam, sendMessageTo, stopListeningTo, urlParam;
  APP_HOSTID = 'app:hostid';
  APP_READY = 'app:ready';
  APP_PARAMS = 'app:params';
  APP_DONE = 'app:done';
  ORIGIN_ALL = '*';
  channels = {};
  listenTo = function(arg) {
    var channel, channelInfo, handler, origin;
    origin = arg.origin, channel = arg.channel, handler = arg.handler;
    if (_.values(channels).length === 0) {
      window.addEventListener('message', handleMessageReceived);
    }
    if (!origin || !channel || !handler) {
      console.log("WARNING: incomplete listening parameters (origin=" + origin + ", channel=" + channel + ")");
      return;
    }
    channelInfo = {
      channel: channel,
      origin: origin,
      handler: handler
    };
    channels[channel] = channelInfo;
    return channelInfo;
  };
  handleMessageReceived = function(evt) {
    var channelInfo, e, error, message, rawMessage;
    rawMessage = evt.data;
    try {
      message = JSON.parse(rawMessage);
    } catch (error) {
      e = error;
      console.log("WARNING: Unable to parse message: " + rawMessage);
      return;
    }
    if (!message.channel) {
      return;
    }
    channelInfo = channels[message.channel];
    if (!channelInfo || channelInfo.origin !== ORIGIN_ALL && channelInfo.origin !== evt.origin) {
      console.log("WARNING: message received from unexpected source (channel=" + message.channel + ", origin=" + evt.origin + ", expectedOrigin=" + (channelInfo != null ? channelInfo.origin : void 0) + ")", message.data, channelInfo);
      return;
    }
    if (!channelInfo.handler) {
      console.log("WARNING: no handler defined for message (channel=" + message.channel + ", origin=" + evt.origin + ")", message.data);
      return;
    }
    return channelInfo.handler(message, evt.origin, evt.source);
  };
  sendMessageTo = function(arg) {
    var channel, data, destination, origin, targetWindow;
    targetWindow = arg.targetWindow, origin = arg.origin, destination = arg.destination, channel = arg.channel, data = arg.data;
    if (!channel || !origin) {
      console.log("WARNING: incomplete message send parameters (channel=" + channel + ", origin=" + origin + ")", data);
    }
    return targetWindow.postMessage(JSON.stringify({
      channel: channel,
      origin: origin,
      destination: destination,
      data: data
    }), destination);
  };
  stopListeningTo = function(channel) {
    if (!channels[channel]) {
      return;
    }
    delete channels[channel];
    if (_.values(channels).length === 0) {
      return window.removeEventListener('message', handleMessageReceived);
    }
  };
  getOrigin = function() {
    var loc, origin;
    loc = window.location;
    origin = loc.protocol + "//" + loc.hostname;
    if (loc.port) {
      origin += ":" + loc.port;
    }
    return origin;
  };
  isHsDebugging = function() {
    var ref;
    return ((ref = hsDebugParam()) != null ? ref.toLowerCase() : void 0) === "true";
  };
  hasHsDebugParam = function() {
    return hsDebugParam() != null;
  };
  hsDebugParam = function() {
    return urlParam('hsDebug');
  };
  urlParam = function(name) {
    var matchedGroups, regex;
    regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    matchedGroups = window.location.search.match(regex);
    return matchedGroups != null ? matchedGroups[1] : void 0;
  };
  passthroughHsDebugParam = function() {
    if (hasHsDebugParam()) {
      return "hsDebug=" + (hsDebugParam());
    } else {
      return "";
    }
  };
  return {
    APP_HOSTID: APP_HOSTID,
    APP_READY: APP_READY,
    APP_PARAMS: APP_PARAMS,
    APP_DONE: APP_DONE,
    ORIGIN_ALL: ORIGIN_ALL,
    listenTo: listenTo,
    handleMessageReceived: handleMessageReceived,
    sendMessageTo: sendMessageTo,
    stopListeningTo: stopListeningTo,
    getOrigin: getOrigin,
    isHsDebugging: isHsDebugging,
    hasHsDebugParam: hasHsDebugParam,
    urlParam: urlParam,
    hsDebugParam: hsDebugParam,
    passthroughHsDebugParam: passthroughHsDebugParam
  };
});
}());

